export default __webpack_public_path__ + "static/media/ChangeLanguageHomeIcon.bcbf7e95.svg";